module.exports = __webpack_public_path__ + "static/media/favebiz-login-staff.de2defdd.png";